import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';
type Props = {
  onClick?: () => void;
  children?: any;
  cancel?: boolean;
  disabled?: boolean;
};
const Button = ({ onClick, children, cancel, disabled }: Props) => {
  return (
    <Container disabled={disabled} type='button' className={clsx(cancel && 'cancel')} onClick={onClick}><span>{children}</span></Container>
  );
};

export default Button;
const Container = styled.button`
display: flex;
height: 48px;
padding: 16px 24px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 8px;
background: #2463EB;
align-self: stretch;
&:active {
  opacity: 0.5;
}

span {
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

&.cancel {
  background: #E5E6EB;
  span {
    color: #1D2129;
  }
}

&:disabled {
  opacity: 0.5;
}
`;
